import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Panel, PanelGroup } from 'react-resizable-panels';
import styles from './styles.module.css';
import ResizeHandle from './ResizeHandle';
import DatabaseService from '../services/database.service.js';
import WorkerBuilder from '../services/builder.worker.js';
import InfoPopup from './InfoPopup.js';
// eslint-disable-next-line import/no-webpack-loader-syntax
import SagWorker from '!../services/sag.worker';
// eslint-disable-next-line import/no-webpack-loader-syntax
import FinishLineWorker from '!../services/finishLine.worker';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { captureScreenshot } from '../common/ScreenshotPerfs.js';
import EventBus from '../common/EventBus';
import '../services/isMobile.js';
import {
  convertDateToString,
  convertDurationToString,
} from '../common/ConvertTools.js';
import Select from 'react-select';
import PerfsCard from './perfs/PerfsCard.js';
import PerfsGrid from './perfs/PerfsGrid.js';
import PerfsLineChart from './perfs/PerfsLineChart.js';
import PerfsMap from './perfs/PerfsMap';
import ExportDropdown from './ExportDrop.js';
import {customSelectTheme} from '../common/CustomSelectTheme.js'

let dateStartLoad = Date.now();
let toastId = [0];

const BoardPerfs = React.memo((props) => {
  const [contentData, setContentData] = useState([]);
  const [contentDataLap1, setContentDataLap1] = useState([]);
  const [contentDataLap2, setContentDataLap2] = useState([]);
  const [contentRun, setContentRun] = useState([]);
  const [liteMode, setLiteMode] = useState(false);
  const [contentRunSelected, setContentRunSelected] = useState(0);
  const [followMode, setFollowMode] = useState(false);

  const mapRef = useRef(null);
  const chartRef = useRef(null);

  const [startMarkerCoordinates, setStartMarkerCoordinates] = useState([]);
  const [endMarkerCoordinates, setEndMarkerCoordinates] = useState([]);

  const [batVariationSag2s, setBatVariationSag2s] = useState([]);
  const [batVariationSag10s, setBatVariationSag10s] = useState([]);

  const [sessionTitle, setSessionTitle] = useState('No session loaded');
  const [sessionDetails, setSessionDetails] = useState('No session loaded');

  const [circuitOptions, setCircuitOptions] = useState([]);
  const [selectedCircuit, setSelectedCircuit] = useState(null);

  const [finishLineGeoJson, setFinishLineGeoJson] = useState(null);

  const markerPositionsRef = useRef(null);

  const key = 'L67Uis9Da5SZCWwoyVMF';

  const mapStyleStreetLight = `https://api.maptiler.com/maps/streets-v2/style.json?key=${key}`;

  const mapStyleSatLight = `https://api.maptiler.com/maps/hybrid/style.json?key=${key}`;

  // const mapStyleDark = `https://api.maptiler.com/maps/637bb09f-68ab-4d68-9c4a-c10792c9f039/style.json?key=${key}`;
  const MAPBOX_ACCESS_TOKEN = 'sk.eyJ1Ijoia294eDMiLCJhIjoiY2xidGU1ZWF5MDI5azN3bXNlNmRoYTJhZSJ9.cHWjuYbOwKb_T4wITm65ZA';


  const [mapStyle, setMapStyle] = useState(localStorage.getItem('perfsMapStyle') ? localStorage.getItem('perfsMapStyle') : mapStyleStreetLight);

  const isDark = localStorage.getItem('themeDark');
  const isDesktop = !window.mobileCheck();

  console.log('BoardPerfs / redraw');

  const removeRoutes = () => {
    let map = mapRef.current.getMap();
    if (map.getLayer('route')) {
      map.removeLayer('route');
    }
    if (map.getSource('route')) {
      map.removeSource('route');
    }
  };


  function toggleLiteModeClick() {
    setLiteMode(!liteMode);
  }

  function toggleFollowModeClick() {
    setFollowMode(!followMode);
  }


  function toggleMapStyleClick() {
    if (mapStyle == mapStyleStreetLight) {
      setMapStyle(mapStyleSatLight);
      localStorage.setItem('perfsMapStyle', mapStyleSatLight);
    } else if (mapStyle == mapStyleSatLight) {
      setMapStyle(mapStyleStreetLight);
      localStorage.setItem('perfsMapStyle', mapStyleStreetLight);
    }
  }

  const loadRuns = () => {
    console.log('BoardPerfs / loadRuns');
    DatabaseService.getPerfsRun()
      .then((response) => {
        setContentRun(response.data);
      })
      .catch((error) => {
        console.log('BoardPerfs / loadRuns / getPerfsRun / error', error);
      });
  };

  useEffect(() => {
    loadRuns();
  }, []);

  const resizeMap = () => {
    if (mapRef.current) {
      mapRef.current.getMap().resize();
    }
  };


  const loadData = (timestamp_p) => {
    
    let toastIdTmp = toast.loading('Loading data...', {
      position: "bottom-right",
      autoClose: false,
    });
    toastId.push(toastIdTmp);

    
    setContentData([]);
    setContentDataLap1([]);
    setContentDataLap2([]);
    setStartMarkerCoordinates([]);
    setEndMarkerCoordinates([]);

    EventBus.dispatch('updateCurrentMarkersCoordinates', [[], []]);

    setBatVariationSag2s('loading...');
    setBatVariationSag10s('loading...');

    resetButtonLaps();

    let contentRunSelectedTmp = contentRun.find((item) => item.timestamp === timestamp_p);
    console.log("contentRunSelectedTmp", contentRunSelectedTmp)
    setContentRunSelected(contentRunSelectedTmp);

    console.log('loadData / contentRunSelectedTmp', contentRunSelectedTmp);
    console.log('loadData / timestamp_p', timestamp_p);
    if (timestamp_p === 0 || timestamp_p === null) {
      return;
    }

    setSessionTitle(
      contentRunSelectedTmp.ble_name +
      ' - ' +
      convertDateToString(contentRunSelectedTmp.timestamp / 1000) +
      ' - ' +
      convertDurationToString(contentRunSelectedTmp.duration / 1000)
    );
    setSessionDetails(contentRunSelectedTmp.timestamp + ' ' + contentRunSelectedTmp.mac_custom);


    dateStartLoad = Date.now();
    console.log('BoardPerfs / loadData / start', dateStartLoad);

    DatabaseService.getPerfsData(timestamp_p).then((response) => {
      console.log('BoardPerfs / loadData / data loaded', Date.now() - dateStartLoad);

      if (chartRef && chartRef.current) {
        chartRef.current?.resetZoom();
      }


      let data = response.data;
      setContentData(data);

      if (data.length === 0) {
        toast.warn('No data in this record. Ensure you have stable internet connection and resend the record from the SmartDisplay application, in the "about" page.', {
          position: "bottom-right",
          autoClose: 20000
        })
      } else {

        setStartMarkerCoordinates([data[0].positionGps_longitude, data[0].positionGps_latitude]);
        setEndMarkerCoordinates([data[data.length - 1].positionGps_longitude, data[data.length - 1].positionGps_latitude]);

        if (contentRunSelectedTmp?.laps) {
          EventBus.dispatch('handleMarkersData', contentRunSelectedTmp?.laps);
          EventBus.dispatch('handleMarkersDataChart', contentRunSelectedTmp?.laps);
        } else {
          EventBus.dispatch('handleMarkersDataReset');
          EventBus.dispatch('handleMarkersData', []);
        }

        markerPositionsRef.current = contentRunSelectedTmp?.laps || [];

        let selectedCircuit = contentRunSelectedTmp?.circuitId;
        if (selectedCircuit) {
          const defaultCircuit = circuitOptions.find((option) => option.value === selectedCircuit) || circuitOptions[0];
          setSelectedCircuit(defaultCircuit);
        } else {
          setSelectedCircuit(circuitOptions[0])
        }

        console.log('BoardPerfs / loadData / data set', Date.now() - dateStartLoad);

        const instance = new WorkerBuilder(SagWorker);
        instance.onmessage = (message) => {
          if (message) {
            console.log('BoardPerfs / Message from worker', message.data);
            if (message.data.timeSlotInSeconds === 2) {
              setBatVariationSag2s('-' + parseFloat(message.data.maxVoltageDrop).toFixed(1) + ' V');
            }
            if (message.data.timeSlotInSeconds === 10) {
              setBatVariationSag10s('-' + parseFloat(message.data.maxVoltageDrop).toFixed(1) + ' V');
            }
          }
        };
        instance.postMessage({
          data: response.data,
          timeSlotInSeconds: 2,
        });
        instance.postMessage({
          data: response.data,
          timeSlotInSeconds: 10,
        });
      }

      toastId.forEach((id) => {
        toast.dismiss(id);
      });
    }).catch((error) => {
      toast.error('Error loading data. Ensure you have stable internet connection.', {
        position: "bottom-right",
        autoClose: 20000
      })
      console.warn('BoardPerfs / loadData / error', error);
    });
  };

  const removeData = (timestamp, device_id) => {
    console.log(timestamp, device_id);
    const confirmed = window.confirm('Are you sure you want to delete this data?');
    if (confirmed) {
      DatabaseService.removePerfsDatas(timestamp, device_id).then((response) => {
        console.log('BoardPerfs / removeData', response);

        if (response.status >= 200 && response.status < 300)
          DatabaseService.removePerfsRun(timestamp, device_id).then((response) => {
            console.log('BoardPerfs / removePerfsRun', response);

            DatabaseService.getPerfsRun().then((response) => {
              setContentRun(response.data);

              if (timestamp === contentRunSelected.timestamp) {
                removeRoutes();
                setStartMarkerCoordinates([]);
                setEndMarkerCoordinates([]);
                setContentData([]);
                setContentRunSelected(0);
                EventBus.dispatch('updateCurrentMarkersCoordinates', [[], []]);
              }
            });
          });
      });
    }
  };

  const handleCircuitChange = (option) => {
    setSelectedCircuit(option);

    DatabaseService.getCircuitsGeojson(option.value).then((response) => {
      setFinishLineGeoJson(response.data[0].finish_geojson);
    });
  };

  useEffect(() => {
    const loadCircuitData = async () => {
      if (selectedCircuit) {
        try {
          DatabaseService.getCircuitsGeojson(selectedCircuit.value).then((response) => {

            let localFinishLineGeoJson = response.data[0].finish_geojson;
            setFinishLineGeoJson(localFinishLineGeoJson);


          });
        } catch (error) {
          console.error('Error loading circuit data:', error);
        }
      }
    };

    loadCircuitData();
  }, [selectedCircuit]);

  useEffect(() => {
    const fetchCircuits = async () => {
      try {
        const response = await DatabaseService.getCircuitsList();
        const options = response.data.map((circuit) => ({
          value: circuit.id,
          label: ((circuit.id > 0) ? ('[' + circuit.country_code + '] ') : '') + circuit.name + ' (' + circuit.id + ')',
        }));

        options.sort((a, b) => {
          if (a.value === 0) return -1;
          if (b.value === 0) return 1;
          return a.label.localeCompare(b.label);
        });
        setCircuitOptions(options);

        if (options.length > 0) {
          let selectedCircuit = JSON.parse(localStorage.getItem('lastCircuit'));
          const defaultCircuit = options.find((option) => option.value === selectedCircuit) || options[0];
          setSelectedCircuit(defaultCircuit);
        }
      } catch (error) {
        console.error('Failed to fetch circuits:', error);
      }
    };

    fetchCircuits();
  }, []);

  // Function to add a new marker
  const addMarker = (position) => {
    // Add the new position and sort the array
    const newPositions = [...markerPositionsRef.current, position].sort((a, b) => a - b);
    markerPositionsRef.current = newPositions;

    EventBus.dispatch('handleMarkersData', newPositions);
    EventBus.dispatch('handleMarkersDataChart', newPositions);
  };

  const refreshLapsAndCircuitData = (circuitId, laps) => {
    // Update the laps and circuitId in contentRunSelected
    const updatedContentRunSelected = { ...contentRunSelected, laps, circuitId };

    // Update the laps and circuitId in contentRun
    const updatedContentRun = contentRun.map(run =>
      run.timestamp === contentRunSelected.timestamp
        ? { ...run, laps, circuitId }
        : run
    );

    // Set the updated state
    setContentRunSelected(updatedContentRunSelected);
    setContentRun(updatedContentRun);
  };

  const [lapsSelected, setLapsSelected] = useState([]);
  const [lapsIsAllSelected, setLapsIsAllSelected] = useState(true);

  const handleButtonClick = (button) => {
    if (button === 'All') {
      setLapsIsAllSelected(true);
      setLapsSelected([]); // Deselect all number buttons
    } else {
      setLapsIsAllSelected(false);
      setLapsSelected(prevSelectedButtons => {
        let newSelection;
        if (prevSelectedButtons.includes(button)) {
          // Deselect the button
          newSelection = prevSelectedButtons.filter(b => b !== button);
        } else {
          // Select the button
          newSelection = [...prevSelectedButtons, button];
          // If more than 2 laps are selected, remove the oldest selection
          if (newSelection.length > 2) {
            newSelection = newSelection.slice(1);
          }
        }

        // If no number buttons are selected, set 'All' as selected
        if (newSelection.length === 0) {
          setLapsIsAllSelected(true);
        }
        return newSelection;
      });
    }
  };

  useEffect(() => {
    if (lapsSelected.length === 0) {
      setContentDataLap1([]);
      setContentDataLap2([]);
      console.log('BoardPerfs / updateLapsData / contentData', contentData.length);
    } else if (lapsSelected.length === 1) {
      const lap1Data = contentData.slice(markerPositionsRef.current[lapsSelected[0]], markerPositionsRef.current[lapsSelected[0] + 1]);
      setContentDataLap1(lap1Data);
      setContentDataLap2([]);
      console.log('BoardPerfs / updateLapsData / lap1Data', lap1Data.length);
      console.log('BoardPerfs / updateLapsData / contentData', contentData.length);
    }
    else if (lapsSelected.length === 2) {
      const lap1Data = contentData.slice(markerPositionsRef.current[lapsSelected[0]], markerPositionsRef.current[lapsSelected[0] + 1]);
      const lap2Data = contentData.slice(markerPositionsRef.current[lapsSelected[1]], markerPositionsRef.current[lapsSelected[1] + 1]);
      setContentDataLap1(lap1Data);
      setContentDataLap2(lap2Data);
      console.log('BoardPerfs / updateLapsData / lap1Data', lap1Data.length);
      console.log('BoardPerfs / updateLapsData / lap2Data', lap2Data.length);
      console.log('BoardPerfs / updateLapsData / contentData', contentData.length);
    }
  }, [lapsSelected])

  const resetButtonLaps = () => {
    setLapsIsAllSelected(true);
    setLapsSelected([]); // Deselect all number buttons
  }

  const setNewContentData = useCallback((newContentData) => {
    setContentData(newContentData);
  }, []);


  const [replayIndex, setReplayIndex] = useState(0);
  const [replayPaused, setReplayPaused] = useState(false);
  const [replayPlaying, setReplayPlaying] = useState(false);
  const [replaySpeed, setReplaySpeed] = useState(1);

  const replayStart = () => {
    setReplayPlaying(true);
    if (replayIndex >= contentData.length - 1) {
      setReplayIndex(0); // Restart from the beginning if at the end
    }
  };

  const replayFaster = () => {
    if (replaySpeed < 5) {
      setReplaySpeed(replaySpeed + 1);
    }
    else {
      setReplaySpeed(1);
    }
  }

  const replayPause = () => {
    setReplayPaused((prev) => !prev);
  };

  const replayStop = () => {
    setReplayPlaying(false);
    setReplayPaused(false);
    setReplayIndex(0);
    EventBus.dispatch('updateCurrentMarkersCoordinates', [[], []]);
  };


  useEffect(() => {
    if (replayPlaying && !replayPaused) {
      let currentDataLap1, nextDataLap1, currentDataLap2, nextDataLap2;
      let timeDiffLap1 = Infinity, timeDiffLap2 = Infinity;

      if (lapsSelected.length === 0) {
        currentDataLap1 = contentData[replayIndex];
        nextDataLap1 = contentData[replayIndex + replaySpeed];
        if (currentDataLap1 && nextDataLap1) {
          timeDiffLap1 = nextDataLap1.date - currentDataLap1.date;
        }
      } else if (lapsSelected.length === 1) {
        currentDataLap1 = contentDataLap1[replayIndex];
        nextDataLap1 = contentDataLap1[replayIndex + replaySpeed];
        if (currentDataLap1 && nextDataLap1) {
          timeDiffLap1 = nextDataLap1.date - currentDataLap1.date;
        }
      } else if (lapsSelected.length === 2) {
        // Handle Lap 1
        currentDataLap1 = contentDataLap1[replayIndex];
        nextDataLap1 = contentDataLap1[replayIndex + replaySpeed];
        if (currentDataLap1 && nextDataLap1) {
          timeDiffLap1 = nextDataLap1.date - currentDataLap1.date;
        }

        // Handle Lap 2
        currentDataLap2 = contentDataLap2[replayIndex];
        nextDataLap2 = contentDataLap2[replayIndex + replaySpeed];
        if (currentDataLap2 && nextDataLap2) {
          timeDiffLap2 = nextDataLap2.date - currentDataLap2.date;
        }
      }

      const timeDiff = Math.min(timeDiffLap1, timeDiffLap2);

      // If both laps are finished, stop the replay
      if (!nextDataLap1 && !nextDataLap2) {
        setReplayPlaying(false);
        setReplayIndex(0);
        return;
      }

      const timer = setTimeout(() => {
        const newIndex = replayIndex + (replaySpeed);
        setReplayIndex(newIndex);

        // Emit event to update the chart
        EventBus.dispatch('replayUpdate', { index: newIndex });

      }, timeDiff / replaySpeed);

      return () => clearTimeout(timer);
    }
  }, [replayPlaying, replayPaused, replayIndex, replaySpeed, contentData, contentDataLap1, contentDataLap2, lapsSelected]);



  return (
    <>
      <ToastContainer />

      {isDesktop && (
        <div className={styles.Container} style={{ height: '92vh', flex: '1' }}>
          <PanelGroup direction='horizontal'>
            <Panel collapsible={true} defaultSize={20} order={1} onResize={() => resizeMap()}>
              <PanelGroup direction='vertical'>
                <Panel className={styles.Panel} collapsible={true}>
                  <PerfsGrid
                    contentRun={contentRun}
                    setContentRun={setContentRun}
                    isDesktop={isDesktop}
                    loadData={loadData}
                    removeData={removeData}
                  />

                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button
                      className='btn btn-outline-primary m-1'
                      style={{ flex: 1 }}
                      onClick={() => {
                        loadRuns();
                      }}
                    >
                      Refresh
                    </button>
                    <button
                      className='btn btn-outline-primary m-1'
                      style={{ flex: 1 }}
                      onClick={() => captureScreenshot(['captureZonePerfs1', 'captureZonePerfs2'], ['captuzeZoneExcl1'])}
                    >
                      Screenshot
                    </button>
                    <button
                      className={`btn m-1 ${liteMode ? 'btn-primary font-weight-bold' : 'btn-outline-primary'}`}
                      style={{ flex: 1 }}
                      onClick={() => toggleLiteModeClick()}
                    >
                      Lite mode
                    </button>
                    <button
                      className={`btn m-1 ${followMode ? 'btn-primary font-weight-bold' : 'btn-outline-primary'}`}
                      style={{ flex: 1 }}
                      onClick={() => toggleFollowModeClick()}
                    >
                      Follow mode
                    </button>
                    <button
                      className='btn m-1 btn-outline-primary'
                      style={{ flex: 1 }}
                      onClick={() => toggleMapStyleClick()}
                    >
                      Street / sat
                    </button>
                  </div>
                </Panel>
                <ResizeHandle iconName={'fa fa-up-down'} />
                <Panel className={styles.Panel} onResize={() => resizeMap()} collapsible={true} id='map'>
                  <PerfsMap
                    startMarkerCoordinates={startMarkerCoordinates}
                    endMarkerCoordinates={endMarkerCoordinates}
                    contentData={contentData}
                    contentDataLap1={contentDataLap1}
                    contentDataLap2={contentDataLap2}
                    contentRunSelected={contentRunSelected}
                    followMode={followMode}
                    lapsSelected={lapsSelected}
                    mapStyle={mapStyle}
                    MAPBOX_ACCESS_TOKEN={MAPBOX_ACCESS_TOKEN}
                    mapRef={mapRef}
                    finishLineGeoJson={finishLineGeoJson}
                    isDesktop={isDesktop}
                  />
                </Panel>
              </PanelGroup>
            </Panel>
            <ResizeHandle iconName={'fa fa-left-right'} />
            <Panel collapsible={false} order={2}>
              <PanelGroup direction='vertical'>
                <Panel className={styles.Panel} collapsible={true} defaultSize={70} minSize={40} order={1}>
                  <div id='captureZonePerfs1' style={{ height: '100%' }}>


                    <h5
                      className='card-title'
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      {sessionTitle}
                      <div style={{ marginLeft: '8px', marginRight: '8px' }} >
                        - Laps :
                      </div>

                      <button
                        className={`btn ${lapsIsAllSelected ? 'btn-primary' : 'btn-outline-primary'}`}
                        style={{ margin: '0 2px' }}
                        onClick={() => handleButtonClick('All')}
                      >
                        All
                      </button>

                      {
                        contentRunSelected?.laps?.map((lap, index) => {
                          // Only create buttons up to one less than the length of laps
                          if (index < contentRunSelected.laps.length - 1) {
                            return (
                              <button
                                key={index}
                                className={`btn ${lapsSelected.includes(index) ? 'btn-primary' : 'btn-outline-primary'}`}
                                style={{ margin: '0 2px' }}
                                onClick={() => handleButtonClick(index)}
                              >
                                {index + 1}
                              </button>
                            );
                          } else {
                            return null; // Skip creating a button for the last item
                          }
                        })
                      }

                      <InfoPopup info={sessionDetails} />

                      <div style={{ flex: 1 }}></div>  {/* Spacer to push remaining content to the left */}
                    </h5>



                    <div style={{ height: 'calc(100% - 120px)' }}>
                      <PerfsLineChart
                        chartRef={chartRef}
                        contentData={contentData}
                        isDesktop={isDesktop}
                        isDark={isDark}
                        contentRunSelected={contentRunSelected}
                        setNewContentData={setNewContentData}
                        contentDataLap1={contentDataLap1}
                        contentDataLap2={contentDataLap2}
                        lapsSelected={lapsSelected}
                      />
                    </div>

                    <div
                      id='captuzeZoneExcl1'
                      style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '5px' }}
                    >
                      {contentRunSelected?.timestamp > 0 && (
                        <>



                          <button
                            className='btn btn-outline-primary m-2'
                            onClick={() => {
                              if (!replayPlaying) {
                                replayStart();
                              } else {
                                replayPause();
                              }
                            }}
                          >
                            <i className={`fa ${replayPlaying && !replayPaused ? 'fa-pause' : 'fa-play'}`} style={{ width: '18px' }} />
                          </button>
                          <button
                            className='btn btn-outline-primary m-2'
                            onClick={() => {
                              replayStop();
                            }}
                          >
                            <i className='fa fa-stop' style={{ width: '18px' }} />
                          </button>
                          <button
                            className='btn btn-outline-primary m-2'
                            onClick={() => {
                              replayFaster();
                            }}
                          >
                            X{replaySpeed}
                          </button>

                          <div style={{ marginRight: '2rem' }}></div>

                          <label style={{ marginRight: '1rem', width: '300px' }}>
                            <Select
                              options={circuitOptions}
                              value={selectedCircuit}
                              isClearable={false}
                              isSearchable={true}
                              onChange={handleCircuitChange}
                              theme={customSelectTheme}
                              menuPlacement="top"
                            />
                          </label>
                          <button
                            className='btn btn-outline-primary m-2'
                            onClick={() => {
                              // Compute laps circuit
                              if (selectedCircuit) {

                                markerPositionsRef.current = [];
                                const instance = new WorkerBuilder(FinishLineWorker);
                                instance.onmessage = (message) => {
                                  if (message && message.data.finishTimes) {
                                    if (message.data.finishTimes.length > 0) {
                                      message.data.finishTimes.forEach((finish) => {
                                        addMarker(finish.timePosition);
                                      });
                                    } else {
                                      EventBus.dispatch('handleMarkersDataReset');
                                      EventBus.dispatch('handleMarkersData', []);
                                    }
                                  }
                                };
                                instance.postMessage({
                                  runData: contentData,
                                  finishLineGeoJson: finishLineGeoJson,
                                });

                              }
                            }}
                          >
                            Compute laps on this circuit
                          </button>

                          <div style={{ marginRight: '2rem' }}></div>

                          <button
                            className='btn btn-outline-primary m-2'
                            onClick={() => {
                              chartRef?.current?.resetZoom();
                            }}
                          >
                            Reset zoom
                          </button>

                          <div style={{ marginRight: '2rem' }}></div>

                          <ExportDropdown contentRunSelected={contentRunSelected} contentData={contentData} />

                        </>
                      )}
                    </div>
                  </div>
                </Panel>
                <ResizeHandle iconName={'fa fa-up-down'} />
                <Panel className={styles.Panel} order={2} collapsible={true}>
                  <div id='captureZonePerfs2' style={{ height: '100%', backgroundColor: 'var(--color-background)' }}>
                    {contentRunSelected?.timestamp > 0 && (
                      <div className='row' style={{ alignItems: 'start' }}>
                        <PerfsCard
                          direction='column'
                          contentRunSelected={contentRunSelected}
                          contentData={contentData}
                          batVariationSag2s={batVariationSag2s}
                          batVariationSag10s={batVariationSag10s}
                          liteMode={!liteMode}
                          selectedCircuitId={selectedCircuit?.value}
                          refreshLapsAndCircuitData={refreshLapsAndCircuitData}
                          isDesktop={isDesktop}
                        />
                      </div>
                    )}
                  </div>
                </Panel>
              </PanelGroup>
            </Panel>
          </PanelGroup>
        </div>
      )}
      {!isDesktop && (
        <>
          <div style={{ flex: '1' }}>
            <PerfsGrid
              contentRun={contentRun}
              setContentRun={setContentRun}
              isDesktop={isDesktop}
              loadData={loadData}
              removeData={removeData}
            />
          </div>

          <div style={{ height: '2vh' }}></div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button
              className='btn btn-outline-primary m-1'
              style={{ flex: 1 }}
              onClick={() => {
                loadRuns();
              }}
            >
              Refresh
            </button>
            <button
              className='btn btn-outline-primary m-1'
              style={{ flex: 1 }}
              onClick={() => captureScreenshot(['captureZonePerfs1', 'captureZonePerfs2'], ['captuzeZoneExcl1'])}
            >
              Screenshot
            </button>
            <button
              className={`btn m-1 ${liteMode ? 'btn-primary font-weight-bold' : 'btn-outline-primary'}`}
              style={{ flex: 1 }}
              onClick={() => toggleLiteModeClick()}
            >
              Lite mode
            </button>
          </div>

          <div style={{ height: '2vh' }}></div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <h5 className='card-title'>{sessionTitle}</h5>
          </div>

          {contentData?.length > 0 && (
            <>
              <div style={{ height: '400px' }}>
                <PerfsLineChart
                  chartRef={chartRef}
                  contentData={contentData}
                  isDesktop={isDesktop}
                  contentRunSelected={contentRunSelected}
                  setNewContentData={setNewContentData}
                  contentDataLap1={contentDataLap1}
                  contentDataLap2={contentDataLap2}
                  lapsSelected={lapsSelected}
                />
              </div>

              <div style={{ height: '2vh' }} />
            </>
          )}

          <div style={{ height: '50vh', flex: '1' }} className='map-container'>
            <PerfsMap
              startMarkerCoordinates={startMarkerCoordinates}
              endMarkerCoordinates={endMarkerCoordinates}
              contentData={contentData}
              contentRunSelected={contentRunSelected}
              followMode={followMode}
              lapsSelected={lapsSelected}
              mapStyle={mapStyle}
              MAPBOX_ACCESS_TOKEN={MAPBOX_ACCESS_TOKEN}
              mapRef={mapRef}
              finishLineGeoJson={finishLineGeoJson}
              isDesktop={isDesktop}
            />
          </div>

          {contentData?.length > 0 && (
            <>
              <div style={{ height: '3vh' }} />
              <div id='captureZonePerfs1'>
                {contentRunSelected.timestamp > 0 && (
                  <div className='custom-row'>
                    <PerfsCard
                      direction='column'
                      contentRunSelected={contentRunSelected}
                      contentData={contentData}
                      batVariationSag2s={batVariationSag2s}
                      batVariationSag10s={batVariationSag10s}
                      selectedCircuitId={selectedCircuit?.value}
                      refreshLapsAndCircuitData={refreshLapsAndCircuitData}
                      liteMode={!liteMode}
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
    </>
  );
});

export default React.memo(BoardPerfs);
